export default {
  header: {
    title: 'Promo-Code oder Geschenkkarte',
  },
  available_codes: {
    title_one: 'Verfügbarer Code ({{count}})',
    title_other: 'Verfügbare Codes ({{count}})',
    min_threshold: 'Min. {{value}}',
    percentage_off: '{{discount}}% Rabatt auf diese Bestellung',
    amount_off: '{{amount}} Rabatt auf diese Bestellung',
  },
  content: {
    input: {
      placeholder: 'Code eingeben',
    },
    buttons: {
      done: 'Fertig',
      apply: 'Anwenden',
      applied: 'Angewendet ✓',
    },
  },
};
